import { Outlet, useParams } from "react-router"

/* Protopia Ecosystem component */
export interface ITestContainerProps {
   
}
const TestContainer = (props: ITestContainerProps): JSX.Element => {
    const {testId} = useParams()
    return <div className='pe-test-container-container w-100'>
       <Outlet />
    </div>
}
export default TestContainer